import React from 'react';

const Gallery = () => {
  const galleryItems = [
    {
      id: 1,
      title: "Elegant Portrait",
      category: "Fashion Editorial",
      image: "https://images.unsplash.com/photo-1469334031218-e382a71b716b?w=600&h=800&fit=crop",
      gallery: "https://images.unsplash.com/photo-1469334031218-e382a71b716b?w=1200&h=1600&fit=crop",
      description: "A stunning fashion portrait showcasing elegance and sophistication in contemporary styling."
    },
    {
      id: 2,
      title: "Urban Chic",
      category: "Street Fashion",
      image: "https://images.unsplash.com/photo-1515886657613-9f3515b0c78f?w=600&h=800&fit=crop",
      gallery: "https://images.unsplash.com/photo-1515886657613-9f3515b0c78f?w=1200&h=1600&fit=crop",
      description: "Modern street fashion photography capturing the essence of urban style and contemporary trends."
    },
    {
      id: 3,
      title: "Haute Couture",
      category: "High Fashion",
      image: "https://images.unsplash.com/photo-1490481651871-ab68de25d43d?w=600&h=800&fit=crop",
      gallery: "https://images.unsplash.com/photo-1490481651871-ab68de25d43d?w=1200&h=1600&fit=crop",
      description: "Luxury fashion photography featuring haute couture designs and artistic composition."
    },
    {
      id: 4,
      title: "Minimalist Beauty",
      category: "Beauty Editorial",
      image: "https://images.unsplash.com/photo-1524504388940-b1c1722653e1?w=600&h=800&fit=crop",
      gallery: "https://images.unsplash.com/photo-1524504388940-b1c1722653e1?w=1200&h=1600&fit=crop",
      description: "Clean, minimalist approach to beauty photography emphasizing natural elegance."
    },
    {
      id: 5,
      title: "Studio Glamour",
      category: "Fashion Portrait",
      image: "https://images.unsplash.com/photo-1509631179647-0177331693ae?w=600&h=800&fit=crop",
      gallery: "https://images.unsplash.com/photo-1509631179647-0177331693ae?w=1200&h=1600&fit=crop",
      description: "Professional studio photography showcasing glamorous fashion and dramatic lighting."
    },
    {
      id: 6,
      title: "Vibrant Style",
      category: "Commercial Fashion",
      image: "https://images.unsplash.com/photo-1445205170230-053b83016050?w=600&h=800&fit=crop",
      gallery: "https://images.unsplash.com/photo-1445205170230-053b83016050?w=1200&h=1600&fit=crop",
      description: "Bold and vibrant fashion photography perfect for commercial campaigns and brand storytelling."
    }
  ];

  return (
    <section id="works" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900">Fashion Gallery.</h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-20">
          {galleryItems.map((item) => (
            <div key={item.id} className="group cursor-pointer">
              <div className="relative overflow-hidden rounded-lg bg-white shadow-lg hover:shadow-xl transition-shadow">
                <img 
                  src={item.image} 
                  alt={item.title}
                  className="w-full h-80 object-cover group-hover:scale-105 transition-transform duration-300"
                />
                <div className="p-6">
                  <h4 className="text-xl font-bold text-gray-900 mb-2">{item.title}</h4>
                  <div className="text-sm text-gray-500 mb-3">{item.category}</div>
                  <p className="text-gray-600 text-sm">{item.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="bg-white rounded-lg p-8 shadow-lg">
          <h3 className="text-3xl font-bold text-center text-gray-900 mb-12">What Our Clients Say</h3>
          
          <div className="grid md:grid-cols-3 gap-8">
            <div className="text-center">
              <img 
                src="https://images.unsplash.com/photo-1494790108755-2616b612b786?w=100&h=100&fit=crop&crop=face" 
                alt="Client" 
                className="w-16 h-16 rounded-full mx-auto mb-4"
              />
              <div className="mb-4">
                <strong className="text-gray-900">Sarah Mitchell</strong>
                <div className="text-sm text-gray-500">Fashion Designer</div>
              </div>
              <p className="text-gray-600">
                Pixel Perfect captured the essence of my collection beautifully. Their attention to detail 
                and creative vision brought my designs to life in ways I never imagined possible.
              </p>
            </div>

            <div className="text-center">
              <img 
                src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop&crop=face" 
                alt="Client" 
                className="w-16 h-16 rounded-full mx-auto mb-4"
              />
              <div className="mb-4">
                <strong className="text-gray-900">James Rodriguez</strong>
                <div className="text-sm text-gray-500">Brand Director</div>
              </div>
              <p className="text-gray-600">
                Working with Pixel Perfect was an exceptional experience. Their professionalism and 
                artistic eye delivered exactly what our brand needed for our campaign.
              </p>
            </div>

            <div className="text-center">
              <img 
                src="https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&h=100&fit=crop&crop=face" 
                alt="Client" 
                className="w-16 h-16 rounded-full mx-auto mb-4"
              />
              <div className="mb-4">
                <strong className="text-gray-900">Emma Thompson</strong>
                <div className="text-sm text-gray-500">Model</div>
              </div>
              <p className="text-gray-600">
                The team at Pixel Perfect made me feel comfortable and confident during the shoot. 
                The final images exceeded all expectations and truly captured my personality.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Gallery;